"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_DIAGNOSTIC_CHECKS = void 0;
var ALL_DIAGNOSTIC_CHECKS = exports.ALL_DIAGNOSTIC_CHECKS = ["BlackMagicFirmwareShutdownRequired", "BlackMagicFirmwareUpdateRequired"];